module.exports = __webpack_public_path__ + "static/meda-provider4-dd3f7f29eb7c25dd0e1058f7c2cf5e06.png";